export default "__VITE_ASSET__51svSkUL__ 600w";